module.exports = {"id":"205343","name":"Jean-Daniel Akpa Akpro","rating":"74","photo":"./data/images/photos/0/205343.png","club":{"name":"Salerne","logo":"./data/images/clubs/Salerne.png"},"positions":["MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Jean-DanielAkpaAkpro0.json
// module id = 1952
// module chunks = 0